export enum AlertTypeId {
  Patient_Enters_Location = 1,
  Patient_Leaves_Location = 2,
  Patient_Max_Time_In_Location = 3,
  Staff_Enters_Location = 4,
  Staff_Leaves_Location = 5,
  Staff_Max_Time_In_Location = 6,
  Staff_Assist = 7,
  Patient_Enters_Phase = 8,
  Staff_Badge_Drop_Reminder = 9,
  Patient_Max_Time_Unattended = 10,
}
